/**
 * DetailInfoContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Wraps event info text and date block in the detail event section.
 */
const DetailInfoContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${14 * Screen.widthRatio}px;
`;

export default DetailInfoContainer;
